function init() {
    const headings = document.querySelectorAll(".heading-animated");

    if (headings.length === 0) {
        return;
    }

    const options = {
        root: null,
        rootMargin: "0px 0px -30% 0px",
        threshold: 0.5
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.fontWeight = "900";
                observer.unobserve(entry.target);
            }
        });
    }, options);

    headings.forEach(heading => {
        observer.observe(heading);
    });
}

export default { init };
